import React from 'react';

const StatusBadge = ({ status }) => {
  const statusConfig = {
    draft: {
      label: 'Draft',
      className: 'bg-amber-50 text-amber-700 border-amber-200',
    },
    published: {
      label: 'Published',
      className: 'bg-emerald-50 text-emerald-700 border-emerald-200',
    },
    archived: {
      label: 'Archived',
      className: 'bg-slate-100 text-slate-700 border-slate-200',
    },
  };

  const config = statusConfig[status] || statusConfig.draft;

  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 text-xs font-semibold rounded-md border tracking-wide uppercase ${config.className}`}>
      {config.label}
    </span>
  );
};

export default StatusBadge;